import httpClient from "../httpClient";

const END_POINT = '/auth';

const login = (credentials) => httpClient.post(`${END_POINT}/login`, credentials);

export {
  login,
}